import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "shared-page" }
const _hoisted_3 = { class: "centeredContentBox grant-permissions" }
const _hoisted_4 = {
  class: "header-left",
  role: "heading"
}
const _hoisted_5 = { class: "grant-permissions-body" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "alertBox textLarge bottomSpaceDouble" }
const _hoisted_8 = { class: "button-section-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CwePageHeader = _resolveComponent("CwePageHeader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CwePageHeader, { authenticationRequired: true }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("grant_permissions_title", [_ctx.provider])), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("grant_permissions_body", [_ctx.provider])), 1),
        (_ctx.pageErrorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.pageErrorMessage), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "button-right",
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.submitHandler && _ctx.submitHandler(...args))),
            "data-testid": "confirmButton"
          }, _toDisplayString(_ctx.$t('confirm_acceptance')), 1),
          _createElementVNode("button", {
            class: "button-right go-back",
            type: "button",
            "data-testid": "cancelButton",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelHandler && _ctx.cancelHandler(...args)))
          }, _toDisplayString(_ctx.$t('cancel')), 1)
        ])
      ])
    ])
  ]))
}